import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { TracksServiceWeb } from '@asset-old/shared/services/analytics/tracks.service';
import { IdsActionButtonModule, IdsContextualButtonModule, IdsDirectionalButtonModule, IdsIconButtonModule, IdsIconModule, IdsMainButtonModule } from '@ids/angular';
import { Contrast } from '@ids/tools';

export type ButtonType = 'icon' | 'action' | 'directional' | 'main' | 'contextual';
export type ButtonVariant = 'primary' | 'secondary' | string;


@Component({
  selector: 'button-new',
  standalone: true,
  imports: [NgTemplateOutlet, IdsIconModule, IdsMainButtonModule, IdsContextualButtonModule, IdsActionButtonModule, IdsDirectionalButtonModule, IdsIconButtonModule],
  templateUrl: './button-new.component.html',
  styleUrl: './button-new.component.css',
  host: {
    '[class]': 'class()'
  }
})
export class ButtonNewComponent {
  private readonly analytics = inject(TracksServiceWeb);

  // Input signals
  readonly btnId = input<string>();
  readonly class = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly icon = input<string>();
  readonly tabindex = input<number>(0);
  readonly type = input<ButtonType>('main');
  readonly variant = input<ButtonVariant>('primary');
  readonly full = input<boolean>(false);
  readonly contrast = input<Contrast>('onVariant');

  // Analytics inputs
  readonly gaPath = input<string>();
  readonly gaLabel = input<string>();

  // Output signal
  readonly onClick = output<MouseEvent>();

  // Check if analytics should be tracked
  private readonly shouldTrack = computed(() => 
    !!(this.gaPath() && this.gaLabel())
  );

  handleClick(event: MouseEvent): void {
    if (this.shouldTrack()) {
      this.analytics.tracks.newEvent(
        'click',
        this.gaPath()!,
        `botao:${this.gaLabel()}`,
        true
      );
    }
    this.onClick.emit(event);
  }
}
